import styled from 'styled-components'
import PostAddOutlined from '@mui/icons-material/PostAddOutlined'
import theme from 'src/styles/theme'
import TextFieldMui from 'src/components/TextFieldMui'

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 10px 40px;
`

export const CustomText = styled.p`
  font-size: 1.1rem;
`

export const ContainerButton = styled.div`
  display: flex;
  gap: 3rem;
  justify-content: flex-start;
  flex: 1 1 100%;
  margin: 1rem 0 0.5rem;
`

export const InputContainer = styled.div`
  display: flex; 
  padding-left: 8px;
  margin-top: 20px;
  margin-bottom: 30px;
  border-left: 3px solid ${theme.colors.blue};
  flex-direction: column;
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 30rem;
`

export const CustomTextField = styled(TextFieldMui)`
  width: 30em;
`

export const CustomPackQtyField = styled(TextFieldMui)`
`

export const PostIcon = styled(PostAddOutlined)`
    color: ${theme.colors.white} !important;
`
